module.exports = __webpack_public_path__ + "img/kleisma1m-m@2.c80b32ae.jpg";